import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { MarkingProductData } from 'src/app/models/integrations/marking/marking-product-list.model';
import { ApiMarkingProductListService } from 'src/app/services';

@Component({
  selector: 'app-marking-product-profile',
  templateUrl: './marking-product-profile.component.html',
  styleUrls: ['./marking-product-profile.component.css']
})
export class MarkingProductProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  listData: MarkingProductData;
  listId: string;

  @Input() set data(value) {

    if (value != null) {

      this.listId = value.id;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private apiMarkingProductService: ApiMarkingProductListService,
    private router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.getProductInfo();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param file
   */
  getProductInfo(): void {

    this.listData = null;
    this.loading = true;

    this.progressRef.start();

    this.subscriptions.add(
      this.apiMarkingProductService.getInfo(this.listId).subscribe(response => {
        console.log("[RESPONSE] getListInfo: ", response);

        if (response != null) {

          this.listData = response.result;

        }

        this.loading = false;
        this.progressRef.complete();
      })
    );
  }

  onEdit(){
    
    this.router.navigate(['products', 'edit', this.listData.product_id]);
    this.activeModal.close(true);
    
  }


}
